import {useState} from "react";

function LessMoreComp({ name, lessMr }) {
        const [lessMore, setLessMore] = useState({});
        const toggleLessMore = (lessMr) => {
            setLessMore({
                ...lessMore,
                [lessMr]: !lessMore[lessMr]
            });
        }
  return (
    <>
   {name && name?.length > 50 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1",cursor:'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name.substring(0, 50)} <span style={{ color: "#0e7fe1",cursor:'pointer'}} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        
    </>
  )
}

export default LessMoreComp